export const apiHeaders = {
  'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
};

export function fetch_post(url: string, formData: any) {

  const form = new FormData();

  Object.keys(formData).map(function (key) {
    form.append(key, formData[key]);
  });

  return fetch(url, {
    method: 'POST',
    headers: apiHeaders,
    credentials: 'same-origin',
    body: form,
  });
}

export function fetch_get(url: string) {

  return fetch(url, {
    method: 'GET',
    headers: apiHeaders,
    credentials: 'same-origin',
  });
}